<pmt-sidebar>
    <!-- Staff-Tool -->
    <pmt-nav-section [titleText]="'main.navbar.staffTool.title' | transloco" iconCode="fa-solid fa-users">
        <ng-container>
            <pmt-nav-item [routerLinkInput]="'staff'" [routerLinkActiveExactOption]="false"
                [text]="('main.navbar.staffTool.staff' | transloco)" iconCode="fa-solid fa-clipboard-user">
            </pmt-nav-item>
            <pmt-nav-item [routerLinkInput]="'documents'" [routerLinkActiveExactOption]="false"
                [text]="('main.navbar.staffTool.documents' | transloco)" iconCode="fa-solid fa-file">
            </pmt-nav-item>
            <pmt-nav-item [routerLinkInput]="'documentCategories'" [routerLinkActiveExactOption]="false"
                [text]="('main.navbar.staffTool.categories' | transloco)" iconCode="fa-solid fa-layer-group">
            </pmt-nav-item>
            <pmt-nav-item [routerLinkInput]="'news'" [routerLinkActiveExactOption]="false"
                [text]="('main.navbar.staffTool.news' | transloco)" iconCode="fa-solid fa-newspaper">
            </pmt-nav-item>
            <pmt-nav-item [routerLinkInput]="'assignmentSchedules'" [routerLinkActiveExactOption]="false"
                [text]="('main.navbar.staffTool.assignmentSchedules' | transloco)"
                iconCode="fa-solid fa-calendar-users">
            </pmt-nav-item>


        </ng-container>
    </pmt-nav-section>


    <ng-container *ngIf="isAdmin">
        <hr>
        <pmt-nav-section [titleText]="'main.navbar.staffToolAdmin.title' | transloco"
            iconCode="fa-solid fa-shield-user">
            <ng-container>
                <pmt-nav-item [routerLinkInput]="'iconMappings'" [routerLinkActiveExactOption]="false"
                    [text]="('main.navbar.staffToolAdmin.iconMappings' | transloco)" iconCode="fa-solid fa-icons">
                </pmt-nav-item>
            </ng-container>
        </pmt-nav-section>
    </ng-container>

    <hr>

    <!-- Other Tools -->
    <pmt-nav-section [titleText]="'main.navbar.otherTools.title' | transloco" iconCode="fa-solid fa-toolbox">

        <ng-container>
            <!-- ToDo: use pmt core once external links are implemented -->
            <li class="mb-2 cursor-pointer temp-link-item">
                <a class="nav-link pmt-nav-link" title="" [href]="toolsOnlineDeskUrl">
                    <i class="fa-desktop fa-solid"></i><span
                        class="ps-1 temp-link-item-text">{{'main.navbar.otherTools.onlineDesk' | transloco}}</span>
                </a>
            </li>
            <li class="mb-2 cursor-pointer temp-link-item">
                <a class="nav-link pmt-nav-link" title="" [href]="toolsWebplannerUrl">
                    <i class="fa-calendar fa-solid"></i><span
                        class="ps-1 temp-link-item-text">{{'main.navbar.otherTools.webPlanner' | transloco}}</span>
                </a>
            </li>
        </ng-container>

        <!-- <ng-container>
            <pmt-nav-item [routerLinkInput]="toolsOnlineDeskUrl" [routerLinkActiveExactOption]="false"
                [text]="('main.navbar.otherTools.onlineDesk' | transloco)" iconCode="fa-solid fa-desktop">
            </pmt-nav-item>
            <pmt-nav-item [routerLinkInput]="toolsWebplannerUrl" [routerLinkActiveExactOption]="false"
                [text]="('main.navbar.otherTools.webPlanner' | transloco)" iconCode="fa-solid fa-calendar">
            </pmt-nav-item>
        </ng-container> -->
    </pmt-nav-section>


    <ng-container *ngIf="isAdmin">
        <hr>

        <!-- Admin -->
        <pmt-nav-section [titleText]="'main.navbar.admin.title' | transloco" iconCode="fa-solid fa-user-ninja">

            <!-- ToDo: use pmt core once external links are implemented -->
            <li class="mb-2 cursor-pointer temp-link-item">
                <a class="nav-link pmt-nav-link" title="" [href]="adminHangfireUrl" target="_blank">
                    <i class="fa-robot fa-solid"></i><span
                        class="ps-1 temp-link-item-text">{{'main.navbar.admin.hangfire' | transloco}}</span>
                </a>
            </li>


            <ng-container *ngIf="isDevOrTestEnvironment">
                <li class="mb-2 cursor-pointer temp-link-item">
                    <a class="nav-link pmt-nav-link" title="" [href]="adminToolMailUrl" target="_blank">
                        <i class="fa-envelope fa-solid"></i><span
                            class="ps-1 temp-link-item-text">{{'main.navbar.admin.mails' | transloco}}</span>
                    </a>
                </li>
            </ng-container>

            <!-- <ng-container>
            <pmt-nav-item [routerLinkInput]="adminHangfireUrl" [routerLinkActiveExactOption]="false"
                [text]="('main.navbar.admin.hangfire' | transloco)" iconCode="fa-solid fa-robot">
            </pmt-nav-item>
        </ng-container>
        <ng-container *ngIf="isDevOrTestEnvironment">
            <pmt-nav-item [routerLinkInput]="adminToolMailUrl" [routerLinkActiveExactOption]="false"
                [text]="('main.navbar.admin.mails' | transloco)" iconCode="fa-solid fa-envelope">
            </pmt-nav-item>
        </ng-container> -->

        </pmt-nav-section>

    </ng-container>

</pmt-sidebar>